import {createApp} from 'vue'
import ArcoVue, {Icon} from '@arco-design/web-vue';
import ArcoVueIcon from '@arco-design/web-vue/es/icon';
import moment from "moment";

import '@arco-design/web-vue/dist/arco.css';
import 'moment/dist/locale/zh-cn'
import "./assets/styles/common.less";
import route from "./route";
import App from './App.vue'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'; 

// const IconFont = Icon.addFromIconFontCn({src: "https://at.alicdn.com/t/c/font_4516010_wqi64lpzuwp.js"})
const IconFont = Icon.addFromIconFontCn({src: "https://at.alicdn.com/t/c/font_4751342_pglf4obgc1j.js"})


moment.locale('zh-cn');

const app = createApp(App);
app.use(ArcoVue, {
    locale: 'zhCN'
}).use(ArcoVueIcon).use(route).use(ElementPlus).component('IconFont', IconFont);
app.config.globalProperties.moment = moment;
app.mount('#app')
